<div class="revenue-chart">
    <div class="revenue-chart__bar">
        <div
            class="revenue-chart__bar-content revenue-chart__bar-content--revenue"
            [attr.title]="locationPerformanceData.revenue | gbp"
            [ngClass]="{
                'revenue-chart__bar-content--revenue-good':
                    locationPerformanceData.estimate_width >
                        locationPerformanceData.good_width && showEstimate,
                'revenue-chart__bar-content--revenue-fail':
                    locationPerformanceData.estimate_width <
                        locationPerformanceData.good_width &&
                    showEstimate,
                'revenue-chart__bar-content--revenue-plain': !showEstimate
            }"
            [ngStyle]="{ width: locationPerformanceData.revenue_width + '%' }"
        ></div>
        <div
            class="revenue-chart__bar-content revenue-chart__bar-content--estimate"
            [attr.title]="
                locationPerformanceData.adjusted_estimate_amount | gbp
            "
            [ngStyle]="{ width: locationPerformanceData.estimate_width + '%' }"
            *ngIf="showEstimate"
        ></div>
        <div
            class="revenue-chart__bar-target revenue-chart__bar-target--good"
            [attr.title]="goodTarget | gbp"
            [ngStyle]="{ left: locationPerformanceData.good_width + '%' }"
        ></div>
        <div
            class="revenue-chart__bar-target revenue-chart__bar-target--orbit"
            [attr.title]="greatTarget | gbp"
            [ngStyle]="{ left: locationPerformanceData.great_width + '%' }"
        ></div>
    </div>
</div>
